// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__297uY","left":"StickyBox_left__3Sscy","right":"StickyBox_right__3rrdw"};